import {replaceLocation} from '@vio/core/src/_web/utils/browser/navigateTo'
import {getFlutterAppBuild} from '@vio/core/src/_web/utils/flutter/getFlutterAppBuild'
import {hasFlutterAppUrlParam} from '@vio/core/src/_web/utils/flutter/hasFlutterAppUrlParam'
import {isFlutterMobileAppUserAgent} from '@vio/core/src/_web/utils/flutter/isFlutterMobileAppUserAgent'
import {
  AuthenticationFlows,
  SourceComponentType
} from '@vio/core/src/auth/types/Auth'
import {getAppEmailSignInUrl} from '@vio/core/src/auth/utils/url'
import {Brand} from '@vio/core/src/brand/types'

import {AUTHENTICATION_CLICK_TIMEOUT_BEFORE_NAVIGATING_AWAY} from './constants'

// App builds up to this one treat /sign-in/email as an unknown deeplink when
// the WebView started on a booking page, so they keep the in-page email step.
const LAST_APP_BUILD_WITHOUT_EMAIL_SIGN_IN = 5736

export const canHandOffEmailSignInToApp = () => {
  // Only browser QA has the param without the user agent: the app sent the
  // user agent before it started adding the param.
  if (!isFlutterMobileAppUserAgent()) return hasFlutterAppUrlParam()

  return (getFlutterAppBuild() ?? 0) > LAST_APP_BUILD_WITHOUT_EMAIL_SIGN_IN
}

/**
 * Deferred like the social buttons, so the click event leaves before the page
 * does. Replaces the page so the sign-in page and its return leave one entry.
 */
export const handOffEmailSignInToApp = ({
  brand,
  sourceComponent,
  flow
}: {
  brand: Brand
  sourceComponent: SourceComponentType
  flow: AuthenticationFlows | null
}) => {
  setTimeout(
    () =>
      replaceLocation(
        getAppEmailSignInUrl({
          brand,
          appEnv: process.env.NEXT_PUBLIC_ENV,
          sourceComponent,
          flow,
          returnUrl: window.location.href
        })
      ),
    AUTHENTICATION_CLICK_TIMEOUT_BEFORE_NAVIGATING_AWAY
  )
}
